import { IconButton, IconButtonProps } from "@mui/material";
import { IconArrowRight } from "src/components/icons-mui/arrow-right";

export const ArrowButton = ({ sx, ...props }: IconButtonProps) => (
    <IconButton
        {...props}
        sx={[
            {
                width: 40,
                height: 40,
                bgcolor: "white",
                border: "1px solid",
                borderColor: "gray.200",
                borderRadius: "50%",
                transition: "all 0.25s",
                "&:hover": { bgcolor: "gray.50" },
                "&:focus, &:active": { bgcolor: "gray.100" },
                "&.Mui-disabled": { bgcolor: "transparent", cursor: "not-allowed", pointerEvents: "auto" },
            },
            ...(Array.isArray(sx) ? sx : [sx]),
        ]}
    >
        <IconArrowRight sx={{ fontSize: 24, color: "gray.800" }} />
    </IconButton>
);
